import { FeatureFlagName } from './feature-flags'

// WARNING! Don't put anything here that you do not want to be exposed to the client.
export const CONFIG = [
  'ASSET_HOST',
  'CONTENT_SERVICE',
  'CONTENT_SERVICE_V2',
  'ALGOLIA_APPLICATION_ID',
  'ALGOLIA_SEARCH_API_KEY',
  'ALGOLIA_CUSTOM_ORIGIN',
  'MAPS_API',
  'SCENTREGROUP_API',
  'SCENTREGROUP_API_KEY',
  'SENTRY_DSN',
  'SENTRY_ENV',
  ...Object.keys(FeatureFlagName),
]

export const CONFIG_PROCESS_ENV_MAP = CONFIG.reduce((acc, key) => {
  acc[key] = process.env[key] // eslint-disable-line no-process-env

  return acc
}, {})
